module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homePageContent page"
  }, [_c('div', {
    staticClass: "page-item page-item-banner"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "catetree"
  }, [_c('div', {
    staticClass: "catetree-title"
  }, [_vm._v("\n                      分类\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "catetree-content"
  }, [_c('ul', _vm._l((_vm.cateTypeList), function(item, i) {
    return _c('li', {
      key: 'cateType_' + i
    }, [_c('i', {
      staticClass: "icon",
      style: ({
        'background-image': 'url(' + item.cateIcon + ')',
        'background-size': 'cover'
      })
    }), _vm._v(" "), _vm._l((item.cateList), function(item1, j) {
      return _c('span', {
        key: 'cateItem_' + j
      }, [_c('a', {
        staticClass: "productCate",
        on: {
          "click": function($event) {
            return _vm.toCate(item1.cateId)
          }
        }
      }, [_vm._v(_vm._s(item1.cateName))]), (j < (item.cateList.length - 1)) ? _c('span', [_vm._v(" / ")]) : _vm._e()])
    })], 2)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "banner-content"
  }, [_c('div', {
    staticClass: "banner-item"
  }, [_c('el-carousel', _vm._l((_vm.carouselConfigList), function(item, i) {
    return _c('el-carousel-item', {
      key: 'carousel_' + i
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.toGoodsDetail(item.productId)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.mediaPath
      }
    })])])
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('div', {
    staticClass: "userinfo-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.isLogined) ? _c('div', {
    staticClass: "userinfo-hello"
  }, [_vm._v("\n                          HI！ "), (_vm.member) ? _c('span', [_vm._v(_vm._s(_vm.member.memberName) + "(" + _vm._s(_vm.member.mobile) + ")")]) : _vm._e(), _vm._v(" 你好！！\n                      ")]) : _c('div', {
    staticClass: "userinfo-hello"
  }, [_vm._v("\n                          HI！你好！！\n                      ")]), _vm._v(" "), (!_vm.isLogined) ? _c('div', {
    staticClass: "userinfo-btns"
  }, [_c('a', {
    staticClass: "loginbtn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toLogin()
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('a', {
    staticClass: "registbtn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toRegister()
      }
    }
  }, [_vm._v("注册")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "userinfo-bottom"
  }, [_c('ul', [(_vm.settings.advertInfo1 && _vm.settings.advertInfo1.advertUrl) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.settings.advertInfo1.advertLink,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.settings.advertInfo1.advertUrl
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.settings.advertInfo2 && _vm.settings.advertInfo2.advertUrl) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.settings.advertInfo2.advertLink,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.settings.advertInfo2.advertUrl
    }
  })])]) : _vm._e()])])])])]), _vm._v(" "), (_vm.messages && _vm.messages.length > 0) ? _c('div', {
    staticClass: "page-item"
  }, [_c('div', {
    staticClass: "content userMessage"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "messageContent"
  }, [_c('el-carousel', {
    attrs: {
      "height": "20px",
      "interval": "5000"
    }
  }, _vm._l((_vm.messages), function(item, index) {
    return _c('el-carousel-item', {
      key: 'carousel_' + index
    }, [_vm._v("   \n                              No." + _vm._s(index + 1) + " " + _vm._s(item.content) + "\n                          ")])
  }), 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-group"
  }, [_c('div', {
    staticClass: "group-content"
  }, [_c('div', {
    staticClass: "page-item"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                          新品榜单\n                          "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toMore(5)
      }
    }
  }, [_vm._v("更多"), _c('i', {
    staticClass: "icon icon-more"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tabcontent"
  }, [_c('ul', _vm._l((_vm.newProductList), function(item, i) {
    return _c('li', {
      key: 'newgoods_' + i
    }, [_c('div', {
      staticClass: "productImage"
    }, [_c('img', {
      staticClass: "billboardImg",
      attrs: {
        "src": item.defaultImage
      },
      on: {
        "click": function($event) {
          return _vm.toGoodsDetail(item.id)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "productname",
      on: {
        "click": function($event) {
          return _vm.toGoodsDetail(item.id)
        }
      }
    }, [_vm._v("\n                                          " + _vm._s(item.name) + "                                     \n                                      ")]), _vm._v(" "), _c('div', {
      staticClass: "productprice"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v("\n                                              ￥" + _vm._s(item.settlementPrice) + "\n                                          ")]), _vm._v(" "), _c('span', {
      staticClass: "sales"
    }, [_vm._v("\n                                              成交" + _vm._s(item.sales) + "件\n                                          ")])]), _vm._v(" "), _c('span', {
      staticClass: "tag"
    }, [_c('i', {
      class: 'icon icon-top-' + (i + 1)
    })]), _vm._v(" "), _c('div', {
      staticClass: "operationBtn1"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.toGoodsDetail(item.id)
        }
      }
    }, [_c('y-button', {
      attrs: {
        "text": "查看详情"
      }
    })], 1), _vm._v(" "), _c('y-button', {
      attrs: {
        "text": "加入购物车",
        "classStyle": "main-btn"
      },
      on: {
        "btnClick": function($event) {
          return _vm.showModal(item)
        }
      }
    })], 1)])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "page-item"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                          热卖榜单\n                          "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toMore(4)
      }
    }
  }, [_vm._v("更多"), _c('i', {
    staticClass: "icon icon-more"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tabcontent"
  }, [_c('ul', _vm._l((_vm.salesProductList), function(item, i) {
    return _c('li', {
      key: 'salesgoods_' + i
    }, [_c('div', {
      staticClass: "productImage"
    }, [_c('img', {
      staticClass: "billboardImg",
      attrs: {
        "src": item.defaultImage
      },
      on: {
        "click": function($event) {
          return _vm.toGoodsDetail(item.id)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "productname",
      on: {
        "click": function($event) {
          return _vm.toGoodsDetail(item.id)
        }
      }
    }, [_vm._v("\n                                          " + _vm._s(item.name) + "\n                                      ")]), _vm._v(" "), _c('div', {
      staticClass: "productprice"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v("\n                                              ￥" + _vm._s(item.settlementPrice) + "\n                                          ")]), _vm._v(" "), _c('span', {
      staticClass: "sales"
    }, [_vm._v("\n                                              成交" + _vm._s(item.sales) + "件\n                                          ")])]), _vm._v(" "), _c('span', {
      staticClass: "tag"
    }, [_c('i', {
      class: 'icon icon-top-' + (i + 1)
    })]), _vm._v(" "), _c('div', {
      staticClass: "operationBtn1"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.toGoodsDetail(item.id)
        }
      }
    }, [_c('y-button', {
      attrs: {
        "text": "查看详情"
      }
    })], 1), _vm._v(" "), _c('y-button', {
      attrs: {
        "text": "加入购物车",
        "classStyle": "main-btn"
      },
      on: {
        "btnClick": function($event) {
          return _vm.showModal(item)
        }
      }
    })], 1)])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-item"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tabnav"
  }, [(!_vm.isShowMoreBrand) ? _c('ul', [_c('li', {
    class: (_vm.brandMenuIndex == 0 ? 'on' : ''),
    on: {
      "click": function($event) {
        return _vm.brandMenu(0)
      }
    }
  }, [_vm._v("\n                          热门推荐\n                      ")]), _vm._v(" "), _vm._l((_vm.showBrandList), function(item, i) {
    return _c('li', {
      key: 'brand_' + i,
      class: (_vm.brandMenuIndex == item.value ? 'on' : ''),
      on: {
        "click": function($event) {
          return _vm.brandMenu(item.value)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(item.name) + "\n                      ")])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isShowMoreBrand) ? _c('a', {
    staticClass: "showmore",
    on: {
      "click": function($event) {
        return _vm.setBrandShow(true)
      }
    }
  }, [_vm._v("展开"), _c('i', {
    staticClass: "icon icon-list"
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowMoreBrand) ? _c('ul', {
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_c('li', {
    class: (_vm.brandMenuIndex == 0 ? 'on' : ''),
    on: {
      "click": function($event) {
        return _vm.brandMenu(0)
      }
    }
  }, [_vm._v("\n                          热门推荐\n                      ")]), _vm._v(" "), _vm._l((_vm.brandList), function(item, i) {
    return _c('li', {
      key: 'brand_' + i,
      class: (_vm.brandMenuIndex == item.value ? 'on' : ''),
      on: {
        "click": function($event) {
          return _vm.brandMenu(item.value)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(item.name) + "\n                      ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isShowMoreBrand) ? _c('a', {
    staticClass: "showmore",
    on: {
      "click": function($event) {
        return _vm.setBrandShow(false)
      }
    }
  }, [_vm._v("收缩"), _c('i', {
    staticClass: "icon icon-list1"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tabcontent"
  }, [_c('ul', _vm._l((_vm.productList), function(item, i) {
    return _c('li', {
      key: 'goods_' + i
    }, [_c('div', {
      staticClass: "recommendProductImage"
    }, [_c('img', {
      staticClass: "recommendImg",
      attrs: {
        "src": item.defaultImage
      },
      on: {
        "click": function($event) {
          return _vm.toGoodsDetail(item.id)
        }
      }
    }), _vm._v(" "), _vm._l((item.labels), function(labelItem, labelIndex) {
      return (labelIndex < 1 && labelItem.labelIcon) ? _c('img', {
        key: labelIndex,
        staticClass: "productIcon",
        attrs: {
          "src": labelItem.labelIcon
        }
      }) : _vm._e()
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "productname",
      staticStyle: {
        "height": "20px"
      },
      on: {
        "click": function($event) {
          return _vm.toGoodsDetail(item.id)
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(item.name) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "productprice"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v("\n                                      ￥" + _vm._s(item.settlementPrice) + "\n                                      "), (item.settlementPrice < item.sellPrice) ? _c('span', {
      staticClass: "scribe"
    }, [_vm._v("\n                                      ￥" + _vm._s(item.sellPrice) + "\n                                  ")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "sales"
    }, [_vm._v("\n                                      成交" + _vm._s(item.sales) + "件\n                                   ")])]), _vm._v(" "), _c('div', {
      staticClass: "operationBtn"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.toGoodsDetail(item.id)
        }
      }
    }, [_c('y-button', {
      attrs: {
        "text": "查看详情"
      }
    })], 1), _vm._v(" "), _c('y-button', {
      attrs: {
        "text": "加入购物车",
        "classStyle": "main-btn"
      },
      on: {
        "btnClick": function($event) {
          return _vm.showModal(item)
        }
      }
    })], 1)])
  }), 0)])])]), _vm._v(" "), _c('selectSpec', {
    ref: "selectSpec"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userinfo-img"
  }, [_c('img', {
    attrs: {
      "src": "http://img.static.knnnj.com/Default/71f25833-e29f-4677-a2f4-4015c1705391-2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messageImage"
  }, [_c('img', {
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/sefd929e8c01c3cf214d5793d23412c75.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_vm._v("\n                  为你推荐\n                  "), _c('span', [_vm._v("根据您的浏览，实时为您推荐爆款商品")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07a5e07b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/homePage/index.vue
// module id = 740
// module chunks = 2